import 'bootstrap/dist/css/bootstrap.min.css'
import App from './App.svelte'
import '/public/css_global.css'
import '/public/css_temp.css'
import '/public/css_z.css'
import '/public/css_zchat.css'
import '/public/css_theme_light.css'
// depois do tema claro: o visual dos campos é único e resolve os dois temas por variáveis,
// então ele precisa vir por último para não ser sobrescrito pelas regras antigas de tema
import '/public/css_z_field.css'
import '/public/css_print.css'

const app = new App({
    target: document.body,
})

export default app
